import { REFRESH_TOKEN_KEY, ACCESS_TOKEN_KEY } from '@/constants';
import jsCookies from 'js-cookie';
import { jwtDecode } from 'jwt-decode';

export function getCookie(key: string) {
  return (jsCookies.get(key) || '') as string;
}

export function setCookie(key: string, value: string, expireSecond: number) {
  const d = new Date();
  d.setTime(d.getTime() + expireSecond * 1000);
  jsCookies.set(key, value, { expires: d });
}

export function getTokenExpireTime(token: string) {
  const decoded = jwtDecode<{ exp: number }>(token);
  if (!decoded || !decoded.exp) {
    return 0;
  }
  return decoded.exp * 1000;
}

export function removeCookie(key: string) {
  jsCookies.remove(key);
}

export function checkTokenExpired(token: string) {
  return getTokenExpireTime(token) < new Date().getTime();
}

function getRemainingExpirationSeconds(expSeconds: number) {
  return (expSeconds - new Date().getTime()) / 1000;
}

export function setCookieUserAuthenticated(
  accessToken: string,
  refreshToken: string,
) {
  const seconds = getRemainingExpirationSeconds(
    getTokenExpireTime(refreshToken),
  );
  setCookie(ACCESS_TOKEN_KEY, accessToken, seconds);
  setCookie(REFRESH_TOKEN_KEY, refreshToken, seconds);
}

export function clearCookieUserAuthenticated() {
  removeCookie(ACCESS_TOKEN_KEY);
  removeCookie(REFRESH_TOKEN_KEY);
}
